import * as React                                  from "react"
import ViewDemographiesModalComponent, { DataRow } from "./view-demographies-modal-component"
import { CardModalNotOkButton }                    from "../../../modal"
import { Demography, LocalAuthority }              from "../../../../model"
import { deleteDemography, updateDemography }      from "../../../../service/sfp/demographies-service-2";

export default class ViewDemographiesModal
extends React.Component<ViewDemographiesModalProps, ViewDemographiesModalState> {
	constructor(props) {
		super(props)
		this.state = {
			data: this.getData(props.demographies),
			demographies: props.demographies
		}
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ data: this.getData(nextProps.demographies) })
	}

	render() {
		return (
			<ViewDemographiesModalComponent consulted={this.props.consulted}
			                                data={this.state.data}
			                                localAuthority={this.props.localAuthority}
			                                onChange={(c, s) => { this.handleChange(c, s) }}
			                                onClickCloseButton={e => { this.props.onClickCloseButton(e) }}
			                                onClickFooterButton={(b, e) => { this.props.onClickFooterButton(b, e) }} />
		)
	}

	private getData(demographies: Demography[]): DataRow[] {
		return demographies.map(demography => ({ ...demography }))
		.sort((a, b) => a.year < b.year ? -1 : 1)
	}

	private handleChange(changes: any[][], source: string): void {
		const demographies = this.state.demographies
		const localAuthorityId = this.props.localAuthority

		if (changes && "edit" === source) {
			changes.forEach(change => {
				const newVal = change[3]
				const oldVal = change[2]
				const row    = change[0]
				const year   = this.state.data[row]["year"]

				let demographyIndex: number
				const demography = demographies.find((demography, index) => {
					if (year === demography.year) {
						demographyIndex = index
						return true
					}
					return false
				})

				if (!newVal) {
					deleteDemography(demography, localAuthorityId)
					.then(
						() => {
							demographies.splice(demographyIndex, 1)
							const data = this.getData(demographies)
							this.setState({ data, demographies })
						}
					)
				} else {
					demography.population = newVal
					updateDemography(demography, localAuthorityId)
					.then(
						() => {
							demographies[demographyIndex]
							const data = this.getData(demographies)
							this.setState({ data, demographies })
						}
					)
				}
			})
		}
	}
}

export interface ViewDemographiesModalProps {
	consulted: boolean
	demographies: Demography[]
	localAuthority: LocalAuthority
	onClickCloseButton(event: React.SyntheticEvent<Element>): void
	onClickFooterButton(button: CardModalNotOkButton, event: React.SyntheticEvent<Element>): void
}

interface ViewDemographiesModalState {
	data: DataRow[]
	demographies: Demography[]
}


// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-detail/view-demographies-modal/index.tsx